<script setup>
import { defineAsyncComponent } from 'vue';
import { VTextField } from 'vuetify/components/VTextField';

const ShipmentRateFilter = defineAsyncComponent(
    () => import('./ShipmentRateFilter.vue')
);
const WarehouseRateFilter = defineAsyncComponent(
    () => import('./WarehouseRateFilter.vue')
);

const emit = defineEmits(['update']);
defineProps({
    hideLabel: {
        type: Boolean,
        default: false
    },
    itemTitle: {
        default: 'name'
    },
    itemValue: {
        default: 'id'
    },
    args: {
        type: Object,
        default: () => ({})
    }
});

const componentType = {
    Shipment: ShipmentRateFilter,
    Package: WarehouseRateFilter,
    Warehouse: WarehouseRateFilter,
    Charge: VTextField,
    Item: VTextField
};

const handleUpdate = (value) => {
    emit('update', value);
};
</script>

<template>
    <component
        :is="componentType[args?.itemType]"
        :hide-label="hideLabel"
        :item-title="itemTitle"
        :item-value="itemValue"
        :args="args"
        @update="handleUpdate"
        v-bind="$attrs"
    >
        <template v-if="$slots.prepend" v-slot:prepend>
            <slot name="prepend"></slot>
        </template>
    </component>
</template>
